<p *ngIf="error" role="alert" class="text-danger">{{ error }}</p>
<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <tt-input ttLabel="resource_name" [ttModel]="page.resource_name" ttReadonly></tt-input>
        <tt-input ttLabel="searchtext" [(ttModel)]="page.searchtext" ttShowClearButton></tt-input>
        <tt-button ttText="srequipments_new" ttIcon="fas fa-plus" (ttClick)="newEquipment()"></tt-button>
    </tt-card>
    <tt-list [ttData]="items" [ttFilter]="page.searchtext" ttBackStyle [ttGoto]="false" (ttClick)="openItem($event)"></tt-list>
</tt-page>
